<script setup lang="ts">
import type { SubjectCode } from '~/models/Subject'
import type { Product, SupportProductName } from '~/models/Product'
import { storeToRefs } from 'pinia'
import useProductStore from '~/stores/product'
import { useUrlBuilder } from '~/composables/useUrlBuilder'
import useText from '~/composables/useText'
import useProductHelper from '~/composables/useProductHelper'
import Button from '~/components/ui/Button.vue'
import AuDialog from '~/components/ui/AuDialog.vue'

const props = defineProps<{
  name: SupportProductName
  products: Product[]
  subjects: SubjectCode[]
}>()

const emit = defineEmits(['close'])
const { resolveBaseUrl } = useUrlBuilder()
const { capitalize } = useText()

const { isSupportName } = useProductHelper()
const { selectedSupportProductName } = storeToRefs(useProductStore())

const selectedSupportProducts = (selected: SupportProductName) => {
  return props.products.filter(product => isSupportName(product, selected))
}
</script>

<template>
  <AuDialog
    :title="capitalize(name)"
    :open="selectedSupportProductName === name"
    @update:open="val => !val && emit('close')"
  >
    <template #content>
      <ul
        v-if="products.length"
        class="grid flex-col gap-2"
      >
        <li
          v-for="product in selectedSupportProducts(name)"
          :key="product.ean"
        >
          <Button
            :to="{ path: resolveBaseUrl(product) }"
            full-width
            center
            size="xl"
          >
            {{ product.aunivers.name }}
          </Button>
        </li>
      </ul>
    </template>
  </AuDialog>
</template>
